<template>
	<div v-if="notification" class="container"
		style="margin-top: 40px;">
		<div class="row">
			<div class="col-lg-6 offset-lg-3">
				<h3 class="text-center">
					Watchlist Notification
				</h3>
				<p class="text-center">
					Generated: {{ moment(notification.created_at).format('hh:mm:ss DD/MM/YYYY Z')
					}}
				</p>
				<div class="row">
					<div class="col-lg-6">
						<h3>Entity</h3>
						<p><strong>Party Name: </strong> {{ notification.entity.party_name }}</p>
						<p><strong>ABN: </strong> {{ notification.entity.abn }}</p>
						<p><strong>ACN: </strong> {{ notification.entity.acn }}</p>
					</div>
					<div class="col-lg-6">
						<template v-if="notification.type == 'case'">
							<h3>Case</h3>
							<p>
								<strong>Case Name:</strong>
								<a target="_blank" :href="'/cases/view/' + notification.case.id">{{
									notification.case.name }}
								</a>
							</p>
							<p><strong>Type:</strong> {{ notification.case.type }}</p>
							<p><strong>Court:</strong> {{ notification.case.court }}</p>
						</template>
						<template v-if="notification.type == 'adjudication'">
							<h3>Adjudication</h3>
							<p>
								<strong>Adjudication Number:</strong>
								<a target="_blank" :href="'/adjudications/view/' + notification.case.id">{{
									notification.case.application_number }}
								</a>
							</p>
							<p><strong>Type:</strong> {{ notification.case.type }}</p>
							<p><strong>Court:</strong> {{ notification.case.court }}</p>
						</template>
						<template v-if="notification.type == 'insolvency_notice'">
							<h3>Insolvency Notice</h3>
							<p>
								<strong>ASIC Notice ID:</strong>
								<a target="_blank" :href="'/insolvencies/view/' + notification.case.id">{{
									notification.case.asic_notice_id }}
								</a>
							</p>
							<p><strong>Type:</strong> {{ notification.case.type }}</p>
							<p><strong>Court:</strong> {{ notification.case.court }}</p>
						</template>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'NotificationView',
		components: {},
		props: {
			uuid: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				notification: null
			}
		},
		computed: {
			user() {
				return this.$store.getters['auth/user']
			}
		},
		mounted() {
			this.fetchNotification();
		},
		methods: {
			fetchNotification: function (page) {
				this.$axios.get(`/api/notifications/${this.uuid}`, {
					params: {
						page: page ? page : null
					}
				}).then((response) => {
					this.notification = response.data.data;
				}).catch(() => {
					toastr.error('Error loading Notification.');
				}).finally(() => {
					//
				});
			},
		}
	}
</script>

<style scoped>

</style>
